import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

const InputGroupWrapper = ({
  children,
  left,
  right,
  className,
  leftClassName,
  rightClassName,
  title,
}) => {
  if (!children) return null;
  if (!left && !right) {
    return title && React.isValidElement(children) && !children.props.title
      ? React.cloneElement(children, { title })
      : children;
  }

  return (
    <div className={classnames('input-group', className)} title={title}>
      {!!left && <span className={leftClassName}>{left}</span>}
      {children}
      {!!right && <span className={rightClassName}>{right}</span>}
    </div>
  );
};
InputGroupWrapper.propTypes = {
  children: PropTypes.node,
  left: PropTypes.node,
  leftClassName: PropTypes.string,
  right: PropTypes.node,
  rightClassName: PropTypes.string,
  className: PropTypes.string,
  title: PropTypes.string,
};
InputGroupWrapper.defaultProps = {
  children: null,
  left: null,
  leftClassName: 'input-group-addon',
  right: null,
  rightClassName: 'input-group-addon',
  className: '',
  title: undefined,
};

export default InputGroupWrapper;
